/*
 * Copyright (C) 2020 Reciprocity, Inc - All Rights Reserved
 * Unauthorized use, copying, distribution, displaying, or public performance
 * of this file, via any medium, is strictly prohibited. All information
 * contained herein is proprietary and confidential and may not be shared
 * with any third party without the express written consent of Reciprocity, Inc.
 */

export enum ProgramStage {
  ScopingStandards = 1,
  ScopingSections = 2,
  ScopingObjectives = 3,
  Mapping = 4,
  Finalizing = 5,
  Final = 6,
}

export const determineProgramStage = program => {
  if (program.scopedCounts.standards === 0) {
    return ProgramStage.ScopingStandards;
  } else if (program.scopedCounts.sections === 0) {
    return ProgramStage.ScopingSections;
  } else if (program.scopedCounts.objectives === 0) {
    return ProgramStage.ScopingObjectives;
  } else if (program.mappings.controls.edgeCount === 0) {
    return ProgramStage.Mapping;
  } else if (program.status.value !== 'Final') {
    return ProgramStage.Finalizing;
  }
  return ProgramStage.Final;
};

export const calculateScopedCounts = program => {
  const countScoped = (objectType: string): number =>
    program.mappings[objectType].edges.filter(e => e.node.status.value === 'In Scope').length;

  return {
    standards: countScoped('standards'),
    sections: countScoped('sections'),
    objectives: countScoped('objectives'),
  };
};

export const calculateCoveredObjectiveCount = (program): Number => {
  const coveredObjectives = program.mappings.objectives.edges.filter(
    e => e.node.status.value === 'In Scope' && e.node.mappings.controls.edgeCount > 0
  ).length;

  return coveredObjectives;
};

export const calculateCoveredObjectiveFinalCount = (program): Number => {
  const controls = program.mappings.controls.edges;
  const final = controls.filter(c => c.node.status.value === 'Final');

  const coveredObjectives = program.mappings.objectives.edges.filter(
    e => e.node.status.value === 'In Scope' && final.length > 0
  ).length;

  return coveredObjectives;
};

export const getScopedObjectiveIds = (program): Number[] => {
  const scopedObjectiveIds = program.mappings.objectives.edges
    .filter(e => e.node.status.value === 'In Scope')
    .map(e => e.node.dbId);

  return scopedObjectiveIds;
};
